<template>
	<div class="line-view">
		<inline-table-view :value="value" @input="input" :columns="_cols" :blank="line.model()">
			<template v-slot:sku="{ item }">
				<input type="text" v-model="item.sku">
			</template>
			<template v-slot:desc="{ item }">
				<input type="text" v-model="item.desc">
			</template>
			<template v-slot:qty="{ item }">
				<input type="text" v-model="item.qty">
			</template>
			<template v-slot:unit_price="{ item }">
				<input type="text" v-model="item.unit_price">
			</template>
			<template v-slot:mod="{ item }">
				<input type="text" v-model="item.mod">
			</template>
			<template v-slot:subtotal="{ item }">
				<div>{{ subtotal(item) }}</div>
			</template>
		</inline-table-view>
		<div class="footer" style="border-top: 1px solid #e9e9e9;">
			<div class="sum">
				<div class="label">Rabat</div>
				<div class="value">{{ format(_discount) }}</div>
			</div>
			<div class="sum">
				<div class="label">Tillæg</div>
				<div class="value">{{ format(_extra) }}</div>
			</div>
			<div class="sum">
				<div class="label">Moms</div>
				<div class="value">{{ format(_vat) }}</div>
			</div>
			<div class="sum" style="border-top: 1px solid #e9e9e9; border-bottom: 3px solid #e9e9e9;">
				<div class="label">Total</div>
				<div class="value">{{ format(_total) }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import line from '../../model/line';

	export default {
		props: ['value'],
		data() {
			return {
				line: line
			};
		},
		computed: {
			_discount() {
				const self = this;
				return this.value.reduce((acc, item) => { return acc + self.calc(item).discount; }, 0);
			},
			_extra() {
				const self = this;
				return this.value.reduce((acc, item) => { return acc + self.calc(item).extra; }, 0);
			},
			_vat() {
				const self = this;
				return this.value.reduce((acc, item) => { return acc + self.calc(item).vat; }, 0);
			},
			_total() {
				const self = this;
				return this.value.reduce((acc, item) => { return acc + self.calc(item).subtotal; }, 0);
			},
			_cols() {
				return [
					{
						label:	'Varenr',
						name:	'sku',
						weight:	'4fr'
					},
					{
						label:	'Beskrivelse',
						name:	'desc',
						weight:	'8fr'
					},
					{
						label:	'Antal',
						name:	'qty',
						align:	'right',
						weight:	'2fr'
					},
					{
						label:	'Stk. pris',
						name:	'unit_price',
						align:	'right',
						weight:	'4fr'
					},
					{
						label:	'Regulering',
						name:	'mod',
						align:	'right',
						weight:	'4fr'
					},
					{
						label:	'Subtotal',
						name:	'subtotal',
						align:	'right',
						weight:	'4fr'
					}
				];
			}
		},
		methods: {
			input(val) {
				this.$emit('input', val);
			},
			calc(item) {
				const total = parseFloat(item.qty) * parseFloat(item.unit_price);
				const mod	= item.mod ? ((parseFloat(item.mod) / 100) * total) : 0;

				console.log(parseFloat(item.qty), parseFloat(item.unit_price));
				console.log('total', total);

				return {
					discount: 	mod < 0 ? mod : 0,
					extra:		mod > 0 ? mod : 0,
					vat:		0,
					subtotal:	total + mod,
					total:		total
				};
			},
			format(num) {
				return num.toFixed(2);
			},
			subtotal(item) {
				const r = this.calc(item).subtotal;
				return isNaN(r) ? '' : this.format(r);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.line-view {
		& > .footer {
			& > .sum {
				display: grid;
				grid-template-columns: 1fr 1fr;

				& > * {
					padding: 6px 0 6px 0;

					&.label {

					}

					&.value {
						text-align: right;
					}
				}
			}
		}
	}
</style>